import { Label, Text } from "react-aria-components";
import { StyledRadio, StyledRadioGroup, StyledIndicator, StyledRadioIcon } from "./radio.style";
import { MDSRadioProps, MDSRadioGroupProps, MDSRadioSlotName } from "./radio.types";
import { getSlot } from "@/mds/utils/slots";
import { MDSIconColor, MDSIconKind } from "@/mds/components/icon";

export const MDSRadio = ({ children, value, ...props }: MDSRadioProps) => {
  return (
    <StyledRadio {...props} value={value}>
      {({ isSelected }) => (
        <>
          <StyledIndicator>
            <StyledRadioIcon
              kind={isSelected ? MDSIconKind.CheckCircleSolid : MDSIconKind.Circle}
              color={isSelected ? MDSIconColor.Selected : MDSIconColor.Secondary}
              boxSize={16}
              size={16}
            />
          </StyledIndicator>
          <Label>{children}</Label>
        </>
      )}
    </StyledRadio>
  );
};

export const MDSRadioGroup = ({
  children,
  label,
  description,
  errorMessage,
  ...props
}: MDSRadioGroupProps) => {
  return (
    <StyledRadioGroup {...props}>
      {label && <Label>{label}</Label>}
      {description && <Text slot="description">{description}</Text>}
      {getSlot(children, MDSRadioSlotName.Before)}
      {children}
      {getSlot(children, MDSRadioSlotName.After)}
      {errorMessage && <Text slot="errorMessage">{errorMessage}</Text>}
    </StyledRadioGroup>
  );
};
